import React from 'react';
import '../css/components/ssDialog.css';

interface ModalDialogProps {
  /** Optional CSS class applied to the dialog wrapper */
  dialogClass?: string;
  /** Callback fired when the close button/image is clicked */
  handleCloseEvent: () => void;
  /** When provided, renders the titled modal variant with a popup header */
  title?: string;
  /** Optional subtitle shown below the title (only in titled variant) */
  subtitle?: string;
  children?: React.ReactNode;
}

/**
 * Legacy modal dialog component with two presentation modes:
 * - With `title`: renders a full popup-header modal (Bootstrap-style modal-dialog)
 * - Without `title`: renders a minimal overlay with a close image
 */
const ModalDialog = ({ dialogClass, handleCloseEvent, title, subtitle, children }: ModalDialogProps) => (
  <div className={title ? 'hs-bookings-container' : 'ss-modal-background'}>
    {
      title ?
        <div className={dialogClass}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="popup-header">
                <div>
                  <h1>{title}</h1>
                  {subtitle ?
                    <h4 className="blue-txt">{subtitle}</h4>
                    :
                    null}
                </div>
                <button type="button" className="close pull-right"
                        aria-label="Close"
                        onClick={handleCloseEvent}>
                  <img alt="" src="../app-images/close.png"/>
                </button>
              </div>
              {children}
            </div>
          </div>
        </div>
        :
        // dialogClass defaults to empty string — original JS concatenated undefined literally but callers always pass a value
        <div className={"ss-dialog " + (dialogClass || '')}>
          <button type="button"
                  className="ss-modal-close-button"
                  aria-label="Close"
                  onClick={handleCloseEvent}>
            <img className="ss-modal-close-img" alt=""
                 src="../app-images/close.png"/>
          </button>
          {children}
        </div>
    }
  </div>
)

export default ModalDialog;
